import { render, staticRenderFns } from "./system-tip.vue?vue&type=template&id=1fbde657"
import script from "./system-tip.vue?vue&type=script&lang=js"
export * from "./system-tip.vue?vue&type=script&lang=js"
import style0 from "./system-tip.vue?vue&type=style&index=0&id=1fbde657&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports